module.exports = __webpack_public_path__ + "img/services-center.1fc407dd.svg";